// @flow

import styled from '@emotion/styled'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import * as text from '../text'

type Props = {
  size: 1 | 2,
  title: React.Node | string,
  subTitle?: React.Node,
  Cta?: React.ComponentType<any>,
  image?: string | React.Node,
  video?: React.Node,
  color?: string,
  align?: string,
  mediaHeight?: string,
  mediaWidth?: string,
}

export const CallToAction = ({
  size,
  title,
  subTitle,
  Cta,
  image,
  color,
  video,
  align,
  mediaHeight,
  mediaWidth,
}: Props) => (
  <Root align={align} size={size}>
    {typeof image === 'string' ? (
      <img src={image} height={mediaHeight} width={mediaWidth} loading="lazy" />
    ) : (
      image
    )}
    {video}
    {size === 1 && (
      <>
        <H1 align={align} color={color}>
          {title}
        </H1>
        {subTitle && (
          <P1 align={align} color={color}>
            {subTitle}
          </P1>
        )}
      </>
    )}
    {size === 2 && (
      <>
        <H2 align={align} color={color}>
          {title}
        </H2>
        {subTitle && (
          <P2 align={align} color={color}>
            {subTitle}
          </P2>
        )}
      </>
    )}

    {Cta && <Cta />}
  </Root>
)

const H1 = styled.h1`
  ${text.heading1};
  color: ${(p) => p.color || p.theme.primary};
  margin-bottom: 25px;

  ${media.mq[1]} {
    margin-bottom: 25px;
    display: inline-block;
  }
  text-align: ${(p) => p.align || 'center'};
`
const H2 = styled.h2`
  ${text.heading2};
  color: ${(p) => p.color || p.theme.primary};
  margin-bottom: 18px;

  ${media.mq[1]} {
    margin-bottom: 25px;
  }
  text-align: ${(p) => p.align || 'center'};
`
const P1 = styled.p`
  ${text.paragraph3};
  ${media.mq[1]} {
    ${text.paragraph1};
    color: ${(p) => p.color || colors.beige};
  }
  color: ${(p) => p.color || colors.beige};
  text-align: ${(p) => p.align || 'center'};
  max-width: ${(p) => {
    const isCenterAlign = !p.align || p.align === 'center'
    return isCenterAlign ? '800px' : 'auto'
  }};
`
const P2 = styled.p`
  ${text.paragraph3};
  ${media.mq[1]} {
    ${text.paragraph2};
    color: ${(p) => p.color || colors.beige};
  }

  color: ${(p) => p.color || colors.beige};

  text-align: ${(p) => p.align || 'center'};
`

export const Root: React.ComponentType<any> = styled.div`
  display: inline-block;
  text-align: ${(p) => (p.size === 2 ? 'center' : 'left')};
  text-align: ${(p) => p.align || 'center'};
  position: relative;
  z-index: 2;
  video {
    max-width: 200px;
    height: auto;
  }
  img,
  div[data-gatsby-image-wrapper] {
    display: inline-block;
    max-height: 110px;
    width: auto;
    margin-bottom: 25px;
  }

  ${media.mq[1]} {
    text-align: center;
    video {
      max-width: 400px;
    }
    img,
    div[data-gatsby-image-wrapper] {
      max-height: 220px;
      margin-bottom: 50px;
    }
  }

  button {
    margin: 30px ${(p) => (p.align === 'left' ? '0' : 'auto')};

    ${media.mq[1]} {
      margin: 40px ${(p) => (p.align === 'left' ? '0' : 'auto')};
    }
  }
`
